export enum ValidationSeverity {
	INFO= "INFO" ,
	WARNING = "WARNING",
	ERROR = "ERROR",
}
